import { AbstractControl, ValidationErrors } from '@angular/forms';

export function nameValidator(control: AbstractControl): ValidationErrors | null {
  const value = (control.value || '').trim();

  // Accepts any Unicode letter, spaces, hyphens, apostrophes, 2-50 chars
  const valid = /^([\p{L}][\p{L} '-]{0,48}[\p{L}])$/u.test(value);

  if (!value || value.length < 2 || value.length > 50 || !valid) {
    return { invalidName: true };
  }
  return null;
}
